import { render, staticRenderFns } from "./MoyasarModal.vue?vue&type=template&id=9284657a&"
import script from "./MoyasarModal.vue?vue&type=script&lang=js&"
export * from "./MoyasarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports